
import styles from './Resume.module.css'
import BlockResume from "../ui/block-resume/BlockResume";

const firstBlock = [
    {
        type: "Computer systems",
        location: "Rigas Technical University / 2022-Present",
        description: "We are delving deep into the realm of computer science, studying programming languages like C and Assembler, grasping hardware nuances. We tackle intricate algorithms, stay updated on emerging software tools, and gain hands-on experience with servers, broadening our knowledge in the ever-evolving field of information technology."
    }
]


const secondBlock = [
    {
        type:"Upwork",
        location:"2020 / 2021 ",
        description:"Freelancer"
    },
    {
        type:"Standard One",
        location:"2021 / 2023 ",
        description:"Junior frontend developer."
    },
    {
        type:"Volunteer Hackaton IASA 2023",
        location:"Kyiv Polytechnical University / 2023 ",
        description:"frontend dev"
    }
]

const Resume = () => {
    return (
        <section className={styles.resume} id='resume'>
            <div className={styles.width}>
                <div className={styles.titleWrapper}>
                    <h1 className={styles.title} >My Resume </h1>
                    <span className={styles.bgTitle}>Resume</span>
                </div>
                <div className={`flex justify-start z-10 relative ${styles.wrapp}`}>
                    <div className={`mr-10 ${styles.dividedBlocks}`}>
                        <h1 className={styles.titleBlock}>Education</h1>
                            <BlockResume props={firstBlock}/>
                    </div>
                    <div className={`${styles.dividedBlocks}`}>
                        <h1 className={styles.titleBlock}>Experience</h1>
                          <BlockResume props={secondBlock}/>
                    </div>
                </div>
            </div>
        </section>
    )
}


export default Resume